import { C as CosmosIconStarFilled$1, d as defineCustomElement$1 } from './p-3d9e8e1c.js';

const CosmosIconStarFilled = CosmosIconStarFilled$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconStarFilled, defineCustomElement };
